import { Instance, SnapshotIn, types } from 'mobx-state-tree';
import { BillingCycleOption, BillingCycleOptions } from 'globals/types';

export interface DetailsProps {
  billingCycleOption?: BillingCycleOption;
  minimumSpending?: string;
  perCustomer?: string;
  totalCustomers?: string;
  trialLeft?: string;
}

export const Details = types.model({
  billingCycleOption: types.optional(
    types.enumeration(BillingCycleOptions),
    BillingCycleOption.MONTHLY
  ),
  minimumSpending: types.maybe(types.string),
  perCustomer: types.maybe(types.string),
  totalCustomers: types.maybe(types.string),
  trialLeft: types.maybe(types.string),
});

export type DetailsSnapshot = SnapshotIn<typeof Details>;
export type DetailsInstance = Instance<typeof Details>;
